import { Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { required } from '@jfs/utils'
import { Dropdown } from '../../../../components/Dropdown'
import { styles } from '../../styles'
export const documentationForm = (isEdit: boolean, calendarIcon: any, getLovsFromKey: any, dateOfExpiry: string) => [
  {
    actionTitle: 'Proceed',
    key: 'documentationForm',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'MERCHANT_DOCUMENT_TYPE',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Document Type/Category *',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            data: getLovsFromKey('DocumentType'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'type',
          },
          {
            fieldName: 'MERCHANT_DOCUMENT_NAME',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Document Name*',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            data: getLovsFromKey('DocumentName'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'name',
          },
          {
            fieldName: 'RID',
            ComponentName: Spacer,
            // label: 'Document Number',
            // placeholder: '',
            // title: isEdit ? 'Select' : undefined,
            // // validationSchema: isEdit ? required : undefined,
            // editable: isEdit,
            // ...styles.textinputStyle(isEdit),
            // type: 'body12',
            // paddingHorizontal: 16,
            testID: 'number',
          },
          {
            fieldName: 'expiry',
            ComponentName: Spacer,
            // label: 'Date of Expiry',
            // placeholder: '',
            // dateValue: dateOfExpiry ?? '',
            // maxDate: new Date().setDate(new Date().getDate() + 365 * 15), //15 years in future
            // validationSchema: undefined,
            // editable: isEdit,
            // ...styles.textinputStyle(isEdit),
            // paddingHorizontal: isEdit ? 8 : undefined,
            // rightComponent: calendarIcon,
            testID: 'expiry',
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const adHeaderData = [
  { title: 'Document name' },
  { title: 'Document Type/Category' },
  { title: 'Document ID' },
  { title: 'Status' },
  { title: 'Action' },
]

export const checkerHeaderData = [
  { title: 'Document name' },
  { title: 'Document Type/Category' },
  { title: 'Document ID' },
  { title: 'Upload ID' },
  { title: 'Status' },
]

export const checkerNewOldHeaderData = [
  { title: 'New Document name' },
  { title: 'Document Type/Category' },
  { title: 'Document ID' },
  { title: 'Old Document name' },
  { title: 'Upload ID' },
  { title: 'Status' },
]

export const subGroupDoc = [
  { title: 'Document name' },
  { title: 'Document Type' },
  { title: 'Document Id' },
  { title: 'Document Status' },
]

export const subGroupDocFlexMap: any = {
  0: 2,
  1: 1,
  2: 1,
  3: 1,
}

export const headerData = [
  {
    title: 'Document Category',
  },
  {
    title: 'Document Name',
  },
  {
    title: 'Document Number',
  },
  {
    title: 'Date of Expiry',
  },
  {
    title: 'Action',
  },
]

export const headerDataWithOutAction = [
  {
    title: 'Document Category',
  },
  {
    title: 'Document Name',
  },
  {
    title: 'Document Number',
  },
  {
    title: 'Date of Expiry',
  },
]
export const createSubGrpHeader = [
  {
    title: 'File Name',
  },
  {
    title: 'Document Type',
  },
  {
    title: 'Document Name',
  },
]

export const flexMapperCreateSubGrp: any = {
  0: 1,
  1: 1,
  2: 1,
}

export const uploadFlexMap: any = {
  0: 2,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
}

export const flexMapperWithIndex: any = {
  0: 2,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
}
export const flexMapperKycDocs: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
}

export const flexMapperKycDocsWithoutAction: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
}
export const adFlexMap: any = {
  0: 2,
  1: 0.7,
  2: 2,
  3: 0.5,
  4: 0.5,
}

export const checkerFlexMap: any = { 0: 2, 1: 0.7, 2: 2, 3: 0.5, 4: 1 }
export const checkerNewOldFlexMap: any = { 0: 2, 1: 0.7, 2: 1, 3: 2, 4: 1, 5: 1 }
